export const ENV_ROUTES = {
    PRODUCTION: "https://controlcenter.gpshopper.com",
    PREPROD: "http://controlcenter.prd.gpshopper.net",
    UAT: "http://login.uat.gpshopper.net",
    DEVELOPMENT: "http://login.dev.gpshopper.net",
    LOCALDEVELOPMENT: "http://login.dev.gpshopper.net"
};

export const ENV_DOMAIN = {
    PRODUCTION: ".gpshopper.com",
    PREPROD: ".prd.gpshopper.net",
    UAT: ".uat.gpshopper.net",
    DEVELOPMENT: ".dev.gpshopper.net",
    LOCALDEVELOPMENT: ".dev.gpshopper.net"
};
